import React from 'react'
import { MatchDetailContent } from './components/MatchDetailContent'

export function MatchDetailPage() {
  return <MatchDetailContent />
}
